import { useState } from 'react'
import { webOrdersApi, type MultisoftResult } from '../crmApi'
import { ApiError } from '../api'

export function WebOrders() {
  const [identifier, setIdentifier] = useState('')
  const [result, setResult] = useState<MultisoftResult | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function lookup() {
    if (!identifier.trim()) return
    setLoading(true); setError(null); setResult(null)
    try {
      setResult(await webOrdersApi.get(identifier.trim()))
    } catch (e) {
      setError(e instanceof ApiError ? `Fel ${e.status}: ${e.body || 'okänt fel'}` : String(e))
    } finally {
      setLoading(false)
    }
  }

  const order = result?.order
  return (
    <div>
      <h1>Webborder (Multisoft)</h1>
      <p className="muted">
        Hämtar order från Multisoft via passthrough. Anropet vidarebefordras oförändrat till Multisoft
        och svaret lagras samtidigt lokalt (kund- och orderuppgifter) i CRM:et.
      </p>

      <div className="card row-form">
        <input placeholder="CustomerIdWsOrder…" value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && void lookup()} />
        <button className="primary" disabled={loading} onClick={() => void lookup()}>
          {loading ? 'Hämtar…' : 'Hämta från Multisoft'}
        </button>
      </div>

      {error && <p className="error">{error}</p>}

      {result && (
        <section className="card">
          <h2>Resultat</h2>
          <dl className="kv">
            <dt>Success</dt><dd>{String(result.success)}</dd>
            {result.errorMessage && <><dt>Felmeddelande</dt><dd>{result.errorMessage}</dd></>}
            {order && <>
              <dt>Kund</dt><dd>{order.firstName} {order.lastName} ({order.customerIdWsOrder})</dd>
              <dt>Order</dt><dd>#{order.orderId} — {order.orderStatus ?? '—'}</dd>
              <dt>Område</dt><dd>{order.deliveryRegion ?? '—'}</dd>
              <dt>Adress</dt><dd>{order.address ?? '—'}</dd>
              <dt>Leveransdatum</dt><dd>{order.dateOccasion ? order.dateOccasion.slice(0, 10) : '—'}</dd>
            </>}
          </dl>
          {order?.orderRows && order.orderRows.length > 0 && (
            <table className="grid" style={{ marginTop: '0.8rem' }}>
              <thead><tr><th>Produkt</th><th>Antal</th><th>Max</th><th>Á-pris</th></tr></thead>
              <tbody>
                {order.orderRows.map((r) => (
                  <tr key={r.orderRowId}>
                    <td>{r.productName}</td><td>{r.numberOfUnits}</td><td>{r.maxNumberOfUnits}</td><td>{r.price.toFixed(2)} kr</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </section>
      )}
    </div>
  )
}
